export default [{
    text: 'в месяц',
    value: 'monthly',
}, {
    text: 'в год',
    value: 'annual',
}];
